import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { PhoneMaskDirective, RadioComponent, TextInputComponent } from 'ddmo-storybook-lib';
import { LABELS } from '../../../../../shared/constants/lables.constants';

@Component({
    selector: 'app-directory-info-form',
    imports: [CommonModule, FormsModule, RadioComponent, TextInputComponent, PhoneMaskDirective],
    templateUrl: './directory-info-form.component.html',
    styleUrl: './directory-info-form.component.scss'
})
export class DirectoryInfoFormComponent {
    @Output() close = new EventEmitter<void>();
    @Output() submit = new EventEmitter<any>();
    @Input() directoryInfo:any
    hasAttemptedSubmit = false;

    formData = {
        weekendHours: null,
        weekendHoursDetails: '',
        morningHours: null,
        morningHoursDetails: '',
        eveningHours: null,
        eveningHoursDetails: '',
        emergencyPhone: null,
        emergencyPhoneDetails: '',
        publicTransit: null,
        publicTransitDetails: '',
        disabledAdults: null,
        disabledAdultsDetails: '',
        disabledChildren: null,
        disabledChildrenDetails: '',
        languages: '',
        website: ''
    };

    PHONE_PATTERN = LABELS.PHONE_PATTERN
    impersonatedUser:any = localStorage.getItem("impersonatedUser") ?? ""

    weekendForm = this.fb.group({ weekendHours: ['', Validators.required] });
    morningHoursForm = this.fb.group({ morningHours: ['', Validators.required] });
    eveningHoursForm = this.fb.group({ eveningHours: ['', Validators.required] });
    emergencyNumberForm = this.fb.group({ emergencyPhone: ['', Validators.required] });
    publicTransitForm = this.fb.group({ publicTransit: ['', Validators.required] });
    disabledAdultsForm = this.fb.group({ disabledAdults: ['', Validators.required] });
    disabledChildrenForm = this.fb.group({ disabledChildren: ['', Validators.required] });

    public directoryFormGroup = new FormGroup({
        phoneNumber: new FormControl('',[Validators.pattern(this.PHONE_PATTERN)]),
        languages: new FormControl(''),
        website: new FormControl('')
      });

    constructor(private fb: FormBuilder) { 
        
    }

    ngOnInit() {
        if(this.directoryInfo){
            this.bindDirectoryDetails()
        }
        this.validatePhone();
        if(this.impersonatedUser){
            this.disableForms();
        }
    }

    bindDirectoryDetails(){
        this.weekendForm.patchValue({
            weekendHours : this.directoryInfo.hasWeekendHours == true?'yes':this.directoryInfo.hasWeekendHours == false?'no':''
        });
        this.morningHoursForm.patchValue({
            morningHours : this.directoryInfo.hasEarlyMorningHours == true?'yes':this.directoryInfo.hasEarlyMorningHours == false?'no':''
        });
        this.eveningHoursForm.patchValue({
            eveningHours : this.directoryInfo.hasLateEveningHours == true?'yes':this.directoryInfo.hasLateEveningHours == false?'no':''
        });
        this.emergencyNumberForm.patchValue({
            emergencyPhone : this.directoryInfo.hasEmergencyPhoneNumber == true?'yes':this.directoryInfo.hasEmergencyPhoneNumber == false?'no':''
        });
        this.publicTransitForm.patchValue({
            publicTransit : this.directoryInfo.hasPublicTransitNearby == true?'yes':this.directoryInfo.hasPublicTransitNearby == false?'no':''
        });
        this.disabledAdultsForm.patchValue({
            disabledAdults : this.directoryInfo.hasDisabledAdultCare == true?'yes':this.directoryInfo.hasDisabledAdultCare == false?'no':''
        });
        this.disabledChildrenForm.patchValue({
            disabledChildren : this.directoryInfo.hasDisabledChildrenCare == true?'yes':this.directoryInfo.hasDisabledChildrenCare == false?'no':''
        });
        this.directoryFormGroup.patchValue({
            phoneNumber: this.directoryInfo.emergencyPhoneNumber??'',
            languages: this.directoryInfo.nonEnglishLanguagesSpoken ?? '',
            website: this.directoryInfo.webSiteAddress ?? ''
        });
    }

    onCancel() {
        this.close.emit();
    }
    validatePhone(){
        const phnCntrl = this.emergencyNumberForm.get('emergencyPhone');
        const phoneNumberControl = this.directoryFormGroup.get('phoneNumber');
        if (!phoneNumberControl) return;
        if(phnCntrl?.value == 'yes'){
            phoneNumberControl.setValidators([Validators.required, Validators.pattern(this.PHONE_PATTERN)]);
        }else{
            phoneNumberControl.setValidators([Validators.pattern(this.PHONE_PATTERN)]);
            phoneNumberControl.reset();
        }
        phoneNumberControl.updateValueAndValidity();
    }

    onSubmit() {
        this.hasAttemptedSubmit = true;
        this.validatePhone();
        this.markControlsAsTouched();
        if (!this.isDirectoryFormValid()) {
            return;
        }
        let directoryObject = {
            "locationDirectoryId": this.directoryInfo?.locationDirectoryId??null,
            "hasWeekendHours": this.weekendForm.get('weekendHours')?.value == 'yes'?true:this.weekendForm.get('weekendHours')?.value == 'no'?false:null,
            "hasEarlyMorningHours": this.morningHoursForm.get('morningHours')?.value == 'yes'?true:this.morningHoursForm.get('morningHours')?.value == 'no'?false:null,
            "hasLateEveningHours": this.eveningHoursForm.get('eveningHours')?.value == 'yes'?true:this.eveningHoursForm.get('eveningHours')?.value == 'no'?false:null,
            "hasEmergencyPhoneNumber": this.emergencyNumberForm.get('emergencyPhone')?.value == 'yes'?true:this.emergencyNumberForm.get('emergencyPhone')?.value == 'no'?false:null,
            "hasPublicTransitNearby": this.publicTransitForm.get('publicTransit')?.value == 'yes'?true:this.publicTransitForm.get('publicTransit')?.value == 'no'?false:null,
            "hasDisabledAdultCare": this.disabledAdultsForm.get('disabledAdults')?.value == 'yes'?true:this.disabledAdultsForm.get('disabledAdults')?.value == 'no'?false:null,
            "hasDisabledChildrenCare": this.disabledChildrenForm.get('disabledChildren')?.value == 'yes'?true:this.disabledChildrenForm.get('disabledChildren')?.value == 'no'?false:null,
            "nonEnglishLanguagesSpoken": this.directoryFormGroup.get('languages')?.value,
            "webSiteAddress": this.directoryFormGroup.get('website')?.value,
            "emergencyPhoneNumber": this.directoryFormGroup.get('phoneNumber')?.value
        }
        this.submit.emit(directoryObject);
    }

    hasRequiredError(formGroup: FormGroup, controlName: string): boolean {
        const control = formGroup.get(controlName);
        return !!control?.hasError('required') && (control.touched || this.hasAttemptedSubmit);
    }

    hasPhoneRequiredError(): boolean {
        const emergencyPhoneControl = this.emergencyNumberForm.get('emergencyPhone');
        const phoneNumberControl = this.directoryFormGroup.get('phoneNumber');
        if (emergencyPhoneControl?.value !== 'yes') {
            return false;
        }
        return !!phoneNumberControl?.hasError('required') && (phoneNumberControl.touched || this.hasAttemptedSubmit);
    }

    private isDirectoryFormValid(): boolean {
        const requiredQuestionForms = [
            this.weekendForm,
            this.morningHoursForm,
            this.eveningHoursForm,
            this.emergencyNumberForm,
            this.publicTransitForm,
            this.disabledAdultsForm,
            this.disabledChildrenForm
        ];
        return requiredQuestionForms.every((form) => form.valid) && this.directoryFormGroup.valid;
    }

    private markControlsAsTouched(): void {
        this.weekendForm.markAllAsTouched();
        this.morningHoursForm.markAllAsTouched();
        this.eveningHoursForm.markAllAsTouched();
        this.emergencyNumberForm.markAllAsTouched();
        this.publicTransitForm.markAllAsTouched();
        this.disabledAdultsForm.markAllAsTouched();
        this.disabledChildrenForm.markAllAsTouched();
        this.directoryFormGroup.markAllAsTouched();
    }

    disableForms(){
        this.weekendForm.disable();
        this.morningHoursForm.disable();
        this.eveningHoursForm.disable();
        this.emergencyNumberForm.disable();
        this.publicTransitForm.disable();
        this.disabledAdultsForm.disable();
        this.disabledChildrenForm.disable();
        this.directoryFormGroup.disable();
    }
}
